/**
 * DATABASE §1 / API §1: IDs are client-generated UUIDv4.
 *
 * This is not cosmetic. An offline device creates a row with its final identity,
 * so outbox replay needs no temp-id reconciliation. `gen_random_uuid()` stays as
 * a column default, but only as a fallback for server-side inserts.
 *
 * REVIEW B5: v7 was specified in an earlier draft and dropped — its benefit is
 * index locality at millions of rows, this database holds thousands, and
 * Postgres has no built-in uuidv7() before 18. Do not reintroduce it here
 * without changing the column defaults too.
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
/**
 * Generate a v4 UUID from the platform's Web Crypto, which both sides have:
 * `globalThis.crypto` is standard in browsers and has been a global in Node
 * since 19 (this workspace requires 22).
 *
 * Deliberately **no `node:crypto` import**. This module is bundled into the
 * PWA, and a static Node import fails the browser build outright — which is how
 * that fallback was found.
 */
export function newId() {
    const cryptoObj = globalThis.crypto;
    if (!cryptoObj || typeof cryptoObj.randomUUID !== 'function') {
        throw new Error('platform has no crypto.randomUUID');
    }
    return cryptoObj.randomUUID();
}
export function isUuid(value) {
    return typeof value === 'string' && UUID_RE.test(value);
}
/**
 * Mutation ids are idempotency keys generated once by the client and replayed
 * from the outbox (API §3.2). Same shape as a row id; named separately because
 * they mean something different.
 */
export const newMutationId = newId;
//# sourceMappingURL=ids.js.map